import { memo } from 'react'

export const ConditionalWrapper = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children

export default memo(ConditionalWrapper)
